
















































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import InformationCard from "@/components/InformationCard.vue";
import InformationCardValues from "@/components/InformationCardValues.vue";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import { Getter } from "vuex-class";
import { ApplicationConfiguration } from "@/types/store";
import { Department } from "@/types/aznconnect_api";
import { NamedValue } from "@/types/types";

@Component({
  components: {
    "information-card": InformationCard,
    "information-card-values": InformationCardValues,
  },
})
export default class SelfReferrerDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Watch("value") onValueChanged(val: boolean, oldVal: boolean) {
    if (!val) {
      this.clearSearchData();
    }
  }

  @Getter("applicationConfiguration")
  applicationConfiguration!: ApplicationConfiguration;

  loading: boolean = false;
  searching: boolean = false;
  patientNumber: string = "";
  patientBsn: string = "";
  patientName: string = "";
  patientBirthDate: string = "";
  validationMessages: Array<string> = [];
  errorMessages: Array<string> = [];
  searchResults: Array<any> = [];
  selectedSearchResult: any = {};
  departments: Array<any> = [];
  selectedDepartmentCode: string = "";

  get show(): boolean {
    return this.value;
  }

  set show(value: boolean) {
    this.$emit("input", value);
  }

  get hasPatientSelected(): boolean {
    return this.selectedSearchResult && this.selectedSearchResult.PatientNumber;
  }

  get isSearchByPatientNumber(): boolean {
    return this.patientNumber != "" && this.patientNumber != null;
  }

  clearSearchData(): void {
    this.patientNumber = "";
    this.patientBsn = "";
    this.patientName = "";
    this.patientBirthDate = "";

    this.clearSearchResults();
  }

  clearSearchResults(): void {
    this.selectedSearchResult = {};
    this.searchResults = [];
    this.validationMessages = [];
    this.errorMessages = [];
  }

  search() {
    this.clearSearchResults();
    this.searching = true;

    var fieldEncounterId = this.generateRandomFieldEncounterId();

    const vm = this;
    AZNCONNECT_API.post("/Patient/Search", {
      fieldEncounterId: fieldEncounterId,
      patientNumber: this.applicationConfiguration
        .patientSearchByPatientNrEnabled
        ? this.patientNumber
        : "",
      patientBsn: this.applicationConfiguration.patientSearchByPatientBsnEnabled
        ? this.patientBsn
        : "",
      patientName: this.applicationConfiguration
        .patientSearchByFamilyNameEnabled
        ? this.patientName
        : "",
      patientBirthDate: this.applicationConfiguration
        .patientSearchByBirthDateEnabled
        ? this.patientBirthDate
        : "",
    }).then(
      function(response) {
        vm.errorMessages = response.data.ErrorMessages;
        vm.validationMessages = response.data.ValidationMessages;
        vm.searchResults = response.data.Results;
        vm.searching = false;
      },
      function(response) {
        // error callback
        vm.searching = false;
      },
    );

    if (vm.applicationConfiguration.patientNumberDepartmentOverruleEnabled) {
      vm.loadAllDepartments();
    }
  }

  async loadAllDepartments() {
    const vm = this;

    return AZNCONNECT_API.get("/Settings/AllDepartments").then(
      function(response) {
        const apiDepartments: Array<Department> = response.data as Array<
          Department
        >;
        const departments: Array<NamedValue> = [];
        for (const apiDepartment of apiDepartments) {
          departments.push(
            new NamedValue(apiDepartment.code, apiDepartment.description),
          );
        }
        departments.unshift(new NamedValue("", "Geen afdeling"));
        vm.departments = departments;
      },
      function(response) {
        // eslint-disable-next-line no-console
        console.error("Unable to load departments");
      },
    );
  }

  createSelfReferrer(): void {
    const vm = this;

    AZNCONNECT_API.post("/Referral/CreateSelfReferrer", {
      PatientInfoModel: {
        Bsn: this.selectedSearchResult.Bsn,
        PatientNumber: this.selectedSearchResult.PatientNumber,
        BirthDate: this.selectedSearchResult.BirthDate,
        Gender: this.selectedSearchResult.Gender,
        FamilyName: this.selectedSearchResult.FamilyName,
        GivenName: this.selectedSearchResult.GivenName,
        PostalCode: this.selectedSearchResult.PostalCode,
        Street: this.selectedSearchResult.Street,
        HouseNumber: this.selectedSearchResult.HouseNumber,
        City: this.selectedSearchResult.City,
        CallMeName: this.selectedSearchResult.CallMeName,
      },
      DestinationDepartmentCode: this.selectedDepartmentCode,
    }).then(
      function(response) {
        //Open detail page
        vm.closeDialog();
        vm.openDetails(response.data);
      },
      function(response) {
        // error callback
        // eslint-disable-next-line no-console
        console.error("Error while creating self referrer");
      },
    );
  }

  openDetails(referenceId: string) {
    var detailPageName = "referral-list-detail";
    this.$router.push({
      name: detailPageName,
      params: { referralId: referenceId || "" },
    });
  }

  closeDialog(): void {
    this.show = false;
  }

  generateRandomFieldEncounterId(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
